import { CommonModule, DOCUMENT } from "@angular/common";
import { Injector, ModuleWithProviders, NgModule } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  KeycloakService,
  KeycloakImplService,
  KeycloakStubService
} from "./+state/services";
import { KEYCLOAK_CONFIG } from "./providers";

@NgModule({
  imports: [CommonModule]
})
export class KeycloakDataAccessModule {
  static withProviders(): ModuleWithProviders<KeycloakDataAccessModule> {
    return {
      ngModule: KeycloakDataAccessModule,
      providers: [
        {
          provide: KeycloakService,
          useFactory: (injector: Injector) => {
            const document = injector.get(DOCUMENT);
            const keycloakConfig = injector.get(KEYCLOAK_CONFIG, null);
            const activatedRoute = injector.get(ActivatedRoute);

            return keycloakConfig
              ? new KeycloakImplService(
                  document,
                  keycloakConfig,
                  activatedRoute
                )
              : KeycloakStubService;
          },
          deps: [Injector]
        }
      ]
    };
  }
}
